export class PdfLibInitializationError extends Error {
  constructor() {
    super("PDF library failed to initialize");
    this.name = "PdfLibInitializationError";
  }
}
